import { render } from "./ReferencesFiles.vue?vue&type=template&id=2ad1adaa"
import script from "./ReferencesFiles.vue?vue&type=script&lang=js"
export * from "./ReferencesFiles.vue?vue&type=script&lang=js"

import "./ReferencesFiles.vue?vue&type=style&index=0&id=2ad1adaa&lang=css"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__